export default "__VITE_ASSET__BY9Eiv69__"